module.exports = __webpack_public_path__ + "img/confirm-demo-en.dc16f0b.png";